var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("section", { staticClass: "gray-area", attrs: { id: "content" } }, [
    _c("div", { staticClass: "container" }, [
      _c(
        "div",
        { staticClass: "row" },
        [
          _c("sdr-breadcrumbs", {
            attrs: { active_item: "fifth", module: _vm.modulo },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "row" }, [
        _c(
          "form",
          {
            on: {
              submit: function ($event) {
                $event.preventDefault()
                return _vm.onSubmit($event)
              },
            },
          },
          [
            _c("div", { staticClass: "container shortcode travel-ideas" }, [
              _c(
                "h1",
                {
                  staticClass: "idea-title",
                  staticStyle: { "margin-bottom": "20px" },
                },
                [
                  _vm._m(0),
                  _vm._v(
                    _vm._s(_vm.pleaseselectpayment[_vm.getCurrentLocale]) +
                      " - tmp: " +
                      _vm._s(_vm.get_RebookingGetRebookingTicketsTotalDirect)
                  ),
                ]
              ),
            ]),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "col-sms-6 col-sm-8 col-md-9",
                attrs: { id: "main" },
              },
              [
                _c("div", { staticClass: "booking-section sdr-box" }, [
                  _c("div", { staticClass: "person-information" }, [
                    _c("h2", [
                      _vm._v(
                        _vm._s(_vm.yourpersonaldata[_vm.getCurrentLocale]) + ":"
                      ),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "form-group row" }, [
                      _c("div", { staticClass: "col-sm-6 col-md-5" }, [
                        _c("label", [
                          _vm._v(
                            _vm._s(_vm.form_companyname[_vm.getCurrentLocale]) +
                              ":"
                          ),
                          _c("small"),
                        ]),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.inputPax_company_payment,
                              expression: "inputPax_company_payment",
                            },
                          ],
                          staticClass: "input-text full-width",
                          class: {
                            invalid: _vm.$v.inputPax_company_payment.$error,
                          },
                          attrs: {
                            type: "text",
                            id: "inputPax_company_payment",
                            name: "inputPax_company_payment",
                            value: "",
                            placeholder: "",
                          },
                          domProps: { value: _vm.inputPax_company_payment },
                          on: {
                            input: [
                              function ($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.inputPax_company_payment =
                                  $event.target.value
                              },
                              function ($event) {
                                _vm.$v.inputPax_company_payment.$touch()
                              },
                            ],
                          },
                        }),
                        _vm._v(" "),
                        _vm.$v.inputPax_company_payment.$dirty &&
                        !_vm.$v.inputPax_company_payment.minLength
                          ? _c("p", { staticClass: "errormsg" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.errmsg_min_company[_vm.getCurrentLocale]
                                )
                              ),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.$v.inputPax_company_payment.$dirty &&
                        !_vm.$v.inputPax_company_payment.maxLength
                          ? _c("p", { staticClass: "errormsg" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.errmsg_max_company[_vm.getCurrentLocale]
                                )
                              ),
                            ])
                          : _vm._e(),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "form-group row",
                        staticStyle: { "margin-bottom": "45px" },
                      },
                      [
                        _c("div", { staticClass: "col-sm-6 col-md-5" }, [
                          _c("label", [
                            _vm._v(
                              _vm._s(
                                _vm.form_salutation[_vm.getCurrentLocale]
                              ) + ":*"
                            ),
                            _c("small"),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "selector" }, [
                            _c(
                              "select",
                              {
                                staticClass: "full-width",
                                attrs: {
                                  id: "inputPax_salutation_payment",
                                  name: "inputPax_salutation_payment",
                                },
                              },
                              _vm._l(
                                _vm.buildSalutations(),
                                function (sal, index) {
                                  return _c(
                                    "option",
                                    {
                                      key: index,
                                      domProps: { value: sal.value },
                                    },
                                    [_vm._v(_vm._s(sal.text))]
                                  )
                                }
                              )
                            ),
                          ]),
                        ]),
                      ]
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "form-group row" }, [
                      _c("div", { staticClass: "col-sm-6 col-md-5" }, [
                        _c("label", [
                          _vm._v(
                            _vm._s(_vm.form_firstname[_vm.getCurrentLocale]) +
                              ":* "
                          ),
                          _c("small"),
                        ]),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.inputPax_firstName_payment,
                              expression: "inputPax_firstName_payment",
                            },
                          ],
                          staticClass: "input-text full-width",
                          class: {
                            invalid: _vm.$v.inputPax_firstName_payment.$error,
                          },
                          attrs: {
                            type: "text",
                            id: "'inputPax_firstName_payment",
                            name: "inputPax_firstName_payment",
                            value: "",
                            placeholder: "",
                          },
                          domProps: { value: _vm.inputPax_firstName_payment },
                          on: {
                            input: [
                              function ($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.inputPax_firstName_payment =
                                  $event.target.value
                              },
                              function ($event) {
                                _vm.$v.inputPax_firstName_payment.$touch()
                              },
                            ],
                          },
                        }),
                        _vm._v(" "),
                        _vm.$v.inputPax_firstName_payment.$dirty &&
                        !_vm.$v.inputPax_firstName_payment.required
                          ? _c("p", { staticClass: "errormsg" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.errmsg_required[_vm.getCurrentLocale]
                                )
                              ),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.$v.inputPax_firstName_payment.$dirty &&
                        !_vm.$v.inputPax_firstName_payment.minLength
                          ? _c("p", { staticClass: "errormsg" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.errmsg_min_firstname[_vm.getCurrentLocale]
                                )
                              ),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.$v.inputPax_firstName_payment.$dirty &&
                        !_vm.$v.inputPax_firstName_payment.maxLength
                          ? _c("p", { staticClass: "errormsg" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.errmsg_max_firstname[_vm.getCurrentLocale]
                                )
                              ),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.$v.inputPax_firstName_payment.$dirty &&
                        !_vm.$v.inputPax_firstName_payment.letterspaces
                          ? _c("p", { staticClass: "errormsg" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.errmsg_letterspaces[_vm.getCurrentLocale]
                                )
                              ),
                            ])
                          : _vm._e(),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "col-sm-6 col-md-5" }, [
                        _c("label", [
                          _vm._v(
                            _vm._s(_vm.form_lastname[_vm.getCurrentLocale]) +
                              ":* "
                          ),
                          _c("small"),
                        ]),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.inputPax_lastName_payment,
                              expression: "inputPax_lastName_payment",
                            },
                          ],
                          staticClass: "input-text full-width",
                          class: {
                            invalid: _vm.$v.inputPax_lastName_payment.$error,
                          },
                          attrs: {
                            type: "text",
                            id: "inputPax_lastName_payment",
                            name: "inputPax_lastName_payment",
                            value: "",
                            placeholder: "",
                          },
                          domProps: { value: _vm.inputPax_lastName_payment },
                          on: {
                            input: [
                              function ($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.inputPax_lastName_payment =
                                  $event.target.value
                              },
                              function ($event) {
                                _vm.$v.inputPax_lastName_payment.$touch()
                              },
                            ],
                          },
                        }),
                        _vm._v(" "),
                        _vm.$v.inputPax_lastName_payment.$dirty &&
                        !_vm.$v.inputPax_lastName_payment.required
                          ? _c("p", { staticClass: "errormsg" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.errmsg_required[_vm.getCurrentLocale]
                                )
                              ),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.$v.inputPax_lastName_payment.$dirty &&
                        !_vm.$v.inputPax_lastName_payment.minLength
                          ? _c("p", { staticClass: "errormsg" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.errmsg_min_lastname[_vm.getCurrentLocale]
                                )
                              ),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.$v.inputPax_lastName_payment.$dirty &&
                        !_vm.$v.inputPax_lastName_payment.maxLength
                          ? _c("p", { staticClass: "errormsg" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.errmsg_max_lastname[_vm.getCurrentLocale]
                                )
                              ),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.$v.inputPax_lastName_payment.$dirty &&
                        !_vm.$v.inputPax_lastName_payment.letterspaces
                          ? _c("p", { staticClass: "errormsg" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.errmsg_letterspaces[_vm.getCurrentLocale]
                                )
                              ),
                            ])
                          : _vm._e(),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "form-group row" }, [
                      _c("div", { staticClass: "col-sm-6 col-md-5" }, [
                        _c("label", [
                          _vm._v(
                            _vm._s(_vm.form_address[_vm.getCurrentLocale]) +
                              ":* "
                          ),
                          _c("small"),
                        ]),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.inputPax_address_payment,
                              expression: "inputPax_address_payment",
                            },
                          ],
                          staticClass: "input-text full-width",
                          class: {
                            invalid: _vm.$v.inputPax_address_payment.$error,
                          },
                          attrs: {
                            type: "text",
                            id: "'inputPax_address_payment",
                            name: "inputPax_address_payment",
                            value: "",
                            placeholder: "",
                          },
                          domProps: { value: _vm.inputPax_address_payment },
                          on: {
                            input: [
                              function ($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.inputPax_address_payment =
                                  $event.target.value
                              },
                              function ($event) {
                                _vm.$v.inputPax_address_payment.$touch()
                              },
                            ],
                          },
                        }),
                        _vm._v(" "),
                        _vm.$v.inputPax_address_payment.$dirty &&
                        !_vm.$v.inputPax_address_payment.required
                          ? _c("p", { staticClass: "errormsg" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.errmsg_required[_vm.getCurrentLocale]
                                )
                              ),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.$v.inputPax_address_payment.$dirty &&
                        !_vm.$v.inputPax_address_payment.minLength
                          ? _c("p", { staticClass: "errormsg" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.errmsg_min_lastname[_vm.getCurrentLocale]
                                )
                              ),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.$v.inputPax_address_payment.$dirty &&
                        !_vm.$v.inputPax_address_payment.maxLength
                          ? _c("p", { staticClass: "errormsg" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.errmsg_max_lastname[_vm.getCurrentLocale]
                                )
                              ),
                            ])
                          : _vm._e(),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "col-sm-6 col-md-5" }, [
                        _c("label", [
                          _vm._v(
                            _vm._s(_vm.form_plz[_vm.getCurrentLocale]) + ":* "
                          ),
                          _c("small"),
                        ]),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.inputPax_plz_payment,
                              expression: "inputPax_plz_payment",
                            },
                          ],
                          staticClass: "input-text full-width",
                          class: {
                            invalid: _vm.$v.inputPax_plz_payment.$error,
                          },
                          attrs: {
                            type: "text",
                            id: "inputPax_plz_payment",
                            name: "inputPax_plz_payment",
                            value: "",
                            placeholder: "",
                          },
                          domProps: { value: _vm.inputPax_plz_payment },
                          on: {
                            input: [
                              function ($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.inputPax_plz_payment = $event.target.value
                              },
                              function ($event) {
                                _vm.$v.inputPax_plz_payment.$touch()
                              },
                            ],
                          },
                        }),
                        _vm._v(" "),
                        _vm.$v.inputPax_plz_payment.$dirty &&
                        !_vm.$v.inputPax_plz_payment.required
                          ? _c("p", { staticClass: "errormsg" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.errmsg_required[_vm.getCurrentLocale]
                                )
                              ),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.$v.inputPax_plz_payment.$dirty &&
                        !_vm.$v.inputPax_plz_payment.numeric
                          ? _c("p", { staticClass: "errormsg" }, [
                              _vm._v(
                                _vm._s(_vm.errmsg_numeric[_vm.getCurrentLocale])
                              ),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.$v.inputPax_plz_payment.$dirty &&
                        !_vm.$v.inputPax_plz_payment.minLength
                          ? _c("p", { staticClass: "errormsg" }, [
                              _vm._v(
                                _vm._s(_vm.errmsg_min_plz[_vm.getCurrentLocale])
                              ),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.$v.inputPax_plz_payment.$dirty &&
                        !_vm.$v.inputPax_plz_payment.maxLength
                          ? _c("p", { staticClass: "errormsg" }, [
                              _vm._v(
                                _vm._s(_vm.errmsg_max_plz[_vm.getCurrentLocale])
                              ),
                            ])
                          : _vm._e(),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "form-group row" }, [
                      _c("div", { staticClass: "col-sm-6 col-md-5" }, [
                        _c("label", [
                          _vm._v(
                            _vm._s(_vm.form_residence[_vm.getCurrentLocale]) +
                              ":* "
                          ),
                          _c("small"),
                        ]),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.inputPax_residence_payment,
                              expression: "inputPax_residence_payment",
                            },
                          ],
                          staticClass: "input-text full-width",
                          class: {
                            invalid: _vm.$v.inputPax_residence_payment.$error,
                          },
                          attrs: {
                            type: "text",
                            id: "'inputPax_residence_payment",
                            name: "inputPax_residence_payment",
                            value: "",
                            placeholder: "",
                          },
                          domProps: { value: _vm.inputPax_residence_payment },
                          on: {
                            input: [
                              function ($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.inputPax_residence_payment =
                                  $event.target.value
                              },
                              function ($event) {
                                _vm.$v.inputPax_residence_payment.$touch()
                              },
                            ],
                          },
                        }),
                        _vm._v(" "),
                        _vm.$v.inputPax_residence_payment.$dirty &&
                        !_vm.$v.inputPax_residence_payment.required
                          ? _c("p", { staticClass: "errormsg" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.errmsg_required[_vm.getCurrentLocale]
                                )
                              ),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.$v.inputPax_residence_payment.$dirty &&
                        !_vm.$v.inputPax_residence_payment.letterspaces
                          ? _c("p", { staticClass: "errormsg" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.errmsg_letterspaces[_vm.getCurrentLocale]
                                )
                              ),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.$v.inputPax_residence_payment.$dirty &&
                        !_vm.$v.inputPax_residence_payment.minLength
                          ? _c("p", { staticClass: "errormsg" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.errmsg_min_residence[_vm.getCurrentLocale]
                                )
                              ),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.$v.inputPax_residence_payment.$dirty &&
                        !_vm.$v.inputPax_residence_payment.maxLength
                          ? _c("p", { staticClass: "errormsg" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.errmsg_max_residence[_vm.getCurrentLocale]
                                )
                              ),
                            ])
                          : _vm._e(),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "col-sm-6 col-md-5" }, [
                        _c("label", [
                          _vm._v(
                            _vm._s(_vm.form_country[_vm.getCurrentLocale]) +
                              ":* "
                          ),
                          _c("small"),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "selector" }, [
                          _c(
                            "select",
                            {
                              staticClass: "full-width",
                              attrs: {
                                id: "inputPax_country_payment",
                                name: "inputPax_country_payment",
                              },
                            },
                            _vm._l(
                              _vm.buildCountries(),
                              function (country, index) {
                                return _c(
                                  "option",
                                  {
                                    key: index,
                                    domProps: { value: country.id },
                                  },
                                  [_vm._v(_vm._s(country.country))]
                                )
                              }
                            )
                          ),
                        ]),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "form-group row" }, [
                      _c("div", { staticClass: "col-sm-6 col-md-5" }, [
                        _c("label", [
                          _vm._v(
                            _vm._s(_vm.form_mobile[_vm.getCurrentLocale]) + ":"
                          ),
                          _c("small"),
                        ]),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.inputPax_mobile_payment,
                              expression: "inputPax_mobile_payment",
                            },
                          ],
                          staticClass: "input-text full-width",
                          class: {
                            invalid: _vm.$v.inputPax_mobile_payment.$error,
                          },
                          attrs: {
                            type: "text",
                            id: "'inputPax_mobile_payment",
                            name: "inputPax_mobile_payment",
                            value: "",
                            placeholder: "",
                          },
                          domProps: { value: _vm.inputPax_mobile_payment },
                          on: {
                            input: [
                              function ($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.inputPax_mobile_payment =
                                  $event.target.value
                              },
                              function ($event) {
                                _vm.$v.inputPax_mobile_payment.$touch()
                              },
                            ],
                          },
                        }),
                        _vm._v(" "),
                        _vm.$v.inputPax_mobile_payment.$dirty &&
                        !_vm.$v.inputPax_mobile_payment.numericspaces
                          ? _c("p", { staticClass: "errormsg" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.errmsg_numericspaces[_vm.getCurrentLocale]
                                )
                              ),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.$v.inputPax_mobile_payment.$dirty &&
                        !_vm.$v.inputPax_mobile_payment.minLength
                          ? _c("p", { staticClass: "errormsg" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.errmsg_min_phone[_vm.getCurrentLocale]
                                )
                              ),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.$v.inputPax_mobile_payment.$dirty &&
                        !_vm.$v.inputPax_mobile_payment.maxLength
                          ? _c("p", { staticClass: "errormsg" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.errmsg_max_phone[_vm.getCurrentLocale]
                                )
                              ),
                            ])
                          : _vm._e(),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "col-sm-6 col-md-5" }, [
                        _c("label", [
                          _vm._v(
                            _vm._s(_vm.form_phone[_vm.getCurrentLocale]) + ":* "
                          ),
                          _c("small"),
                        ]),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.inputPax_phone_payment,
                              expression: "inputPax_phone_payment",
                            },
                          ],
                          staticClass: "input-text full-width",
                          class: {
                            invalid: _vm.$v.inputPax_phone_payment.$error,
                          },
                          attrs: {
                            type: "text",
                            id: "inputPax_phone_payment",
                            name: "inputPax_phone_payment",
                            value: "",
                            placeholder: "",
                          },
                          domProps: { value: _vm.inputPax_phone_payment },
                          on: {
                            input: [
                              function ($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.inputPax_phone_payment = $event.target.value
                              },
                              function ($event) {
                                _vm.$v.inputPax_phone_payment.$touch()
                              },
                            ],
                          },
                        }),
                        _vm._v(" "),
                        _vm.$v.inputPax_phone_payment.$dirty &&
                        !_vm.$v.inputPax_phone_payment.required
                          ? _c("p", { staticClass: "errormsg" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.errmsg_required[_vm.getCurrentLocale]
                                )
                              ),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.$v.inputPax_phone_payment.$dirty &&
                        !_vm.$v.inputPax_phone_payment.numericspaces
                          ? _c("p", { staticClass: "errormsg" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.errmsg_numericspaces[_vm.getCurrentLocale]
                                )
                              ),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.$v.inputPax_phone_payment.$dirty &&
                        !_vm.$v.inputPax_phone_payment.minLength
                          ? _c("p", { staticClass: "errormsg" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.errmsg_min_phone[_vm.getCurrentLocale]
                                )
                              ),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.$v.inputPax_phone_payment.$dirty &&
                        !_vm.$v.inputPax_phone_payment.maxLength
                          ? _c("p", { staticClass: "errormsg" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.errmsg_max_phone[_vm.getCurrentLocale]
                                )
                              ),
                            ])
                          : _vm._e(),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "form-group row" }, [
                      _c("div", { staticClass: "col-sm-6 col-md-5" }, [
                        _c("label", [
                          _vm._v(
                            _vm._s(_vm.form_email[_vm.getCurrentLocale]) + ":* "
                          ),
                          _c("small"),
                        ]),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.inputPax_email_payment,
                              expression: "inputPax_email_payment",
                            },
                          ],
                          staticClass: "input-text full-width",
                          class: {
                            invalid: _vm.$v.inputPax_email_payment.$error,
                          },
                          attrs: {
                            type: "text",
                            id: "inputPax_email_payment",
                            name: "inputPax_email_payment",
                            value: "",
                            placeholder: "",
                          },
                          domProps: { value: _vm.inputPax_email_payment },
                          on: {
                            input: [
                              function ($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.inputPax_email_payment = $event.target.value
                              },
                              function ($event) {
                                _vm.$v.inputPax_email_payment.$touch()
                              },
                            ],
                          },
                        }),
                        _vm._v(" "),
                        _vm.$v.inputPax_email_payment.$dirty &&
                        !_vm.$v.inputPax_email_payment.required
                          ? _c("p", { staticClass: "errormsg" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.errmsg_required[_vm.getCurrentLocale]
                                )
                              ),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        !_vm.$v.inputPax_email_payment.email
                          ? _c("p", { staticClass: "errormsg" }, [
                              _vm._v(
                                _vm._s(_vm.errmsg_email[_vm.getCurrentLocale])
                              ),
                            ])
                          : _vm._e(),
                      ]),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("br"),
                  _c("hr"),
                  _c("br"),
                  _vm._v(" "),
                  !_vm.isItAnOOPayment
                    ? _c("div", { staticClass: "choose-information" }, [
                        _c("h2", [
                          _vm._v(
                            _vm._s(
                              _vm.selectpaymentinfo[_vm.getCurrentLocale]
                            ) + ":"
                          ),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "form-group row" }, [
                          _c("div", { staticClass: "col-sm-12 col-md-10" }, [
                            _c("div", { staticClass: "selector" }, [
                              _c(
                                "select",
                                {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.inputPay_payment,
                                      expression: "inputPay_payment",
                                    },
                                  ],
                                  staticClass: "full-width",
                                  class: {
                                    invalid: !_vm.$v.inputPay_payment.required,
                                  },
                                  attrs: {
                                    id: "inputPay_payment",
                                    name: "inputPay_payment",
                                  },
                                  on: {
                                    input: function ($event) {
                                      _vm.$v.inputPay_payment.$touch()
                                    },
                                    change: [
                                      function ($event) {
                                        var $$selectedVal =
                                          Array.prototype.filter
                                            .call(
                                              $event.target.options,
                                              function (o) {
                                                return o.selected
                                              }
                                            )
                                            .map(function (o) {
                                              var val =
                                                "_value" in o
                                                  ? o._value
                                                  : o.value
                                              return val
                                            })
                                        _vm.inputPay_payment = $event.target
                                          .multiple
                                          ? $$selectedVal
                                          : $$selectedVal[0]
                                      },
                                      function ($event) {
                                        _vm.onChangePaymentMethod($event)
                                      },
                                    ],
                                  },
                                },
                                [
                                  _c("option", { attrs: { value: "" } }, [
                                    _vm._v(
                                      _vm._s(
                                        this.paymentmethod_pleaseselect[
                                          this.getCurrentLocale
                                        ]
                                      )
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _vm._l(
                                    _vm.buildPayments(),
                                    function (sal, index) {
                                      return _c(
                                        "option",
                                        {
                                          key: index,
                                          domProps: { value: sal.value },
                                        },
                                        [_vm._v(_vm._s(sal.text))]
                                      )
                                    }
                                  ),
                                ],
                                2
                              ),
                              _vm._v(" "),
                              !_vm.$v.inputPay_payment.required
                                ? _c("p", { staticClass: "errormsg" }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm.errmsg_required_2[
                                          _vm.getCurrentLocale
                                        ]
                                      )
                                    ),
                                  ])
                                : _vm._e(),
                            ]),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c("br"),
                        _c("br"),
                        _c("hr"),
                        _c("br"),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.showCreditcard,
                          expression: "showCreditcard",
                        },
                      ],
                      staticClass: "card-information",
                    },
                    [
                      _c("h2", [
                        _vm._v(
                          _vm._s(_vm.yourcardinfo[_vm.getCurrentLocale]) + ":"
                        ),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "form-group row" }, [
                        _c("div", { staticClass: "col-sm-6 col-md-5" }, [
                          _c("label", [
                            _vm._v(
                              _vm._s(_vm.form_cc_type[_vm.getCurrentLocale]) +
                                ":* "
                            ),
                            _c("small"),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "selector" }, [
                            _c(
                              "select",
                              {
                                staticClass: "full-width",
                                attrs: {
                                  id: "inputPayment_cc_type",
                                  name: "inputPayment_cc_type",
                                },
                              },
                              _vm._l(
                                _vm.buildCreditcards(),
                                function (card, index) {
                                  return _c(
                                    "option",
                                    {
                                      key: index,
                                      domProps: { value: card.id },
                                    },
                                    [_vm._v(_vm._s(card.card))]
                                  )
                                }
                              )
                            ),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "col-sm-6 col-md-5" }, [
                          _c("label", [
                            _vm._v(
                              _vm._s(_vm.form_cc_holder[_vm.getCurrentLocale]) +
                                ":* "
                            ),
                            _c("small"),
                          ]),
                          _vm._v(" "),
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.inputPayment_cc_holder,
                                expression: "inputPayment_cc_holder",
                              },
                            ],
                            staticClass: "input-text full-width",
                            class: {
                              invalid: _vm.$v.inputPayment_cc_holder.$error,
                            },
                            attrs: {
                              type: "text",
                              id: "'inputPayment_cc_holder",
                              name: "inputPayment_cc_holder",
                              value: "",
                              placeholder: "",
                            },
                            domProps: { value: _vm.inputPayment_cc_holder },
                            on: {
                              input: [
                                function ($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.inputPayment_cc_holder =
                                    $event.target.value
                                },
                                function ($event) {
                                  _vm.$v.inputPayment_cc_holder.$touch()
                                },
                              ],
                            },
                          }),
                          _vm._v(" "),
                          _vm.$v.inputPayment_cc_holder.$dirty &&
                          !_vm.$v.inputPayment_cc_holder.required
                            ? _c("p", { staticClass: "errormsg" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.errmsg_required[_vm.getCurrentLocale]
                                  )
                                ),
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.$v.inputPayment_cc_holder.$dirty &&
                          !_vm.$v.inputPayment_cc_holder.minLength
                            ? _c("p", { staticClass: "errormsg" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.errmsg_min_company[_vm.getCurrentLocale]
                                  )
                                ),
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.$v.inputPayment_cc_holder.$dirty &&
                          !_vm.$v.inputPayment_cc_holder.maxLength
                            ? _c("p", { staticClass: "errormsg" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.errmsg_max_company[_vm.getCurrentLocale]
                                  )
                                ),
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.$v.inputPayment_cc_holder.$dirty &&
                          !_vm.$v.inputPayment_cc_holder.letterspaces
                            ? _c("p", { staticClass: "errormsg" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.errmsg_letterspaces[
                                      _vm.getCurrentLocale
                                    ]
                                  )
                                ),
                              ])
                            : _vm._e(),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "form-group row" }, [
                        _c("div", { staticClass: "col-sm-6 col-md-5" }, [
                          _c("label", [
                            _vm._v(
                              _vm._s(_vm.form_cc_number[_vm.getCurrentLocale]) +
                                ":* "
                            ),
                            _c("small"),
                          ]),
                          _vm._v(" "),
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.inputPayment_cc_number,
                                expression: "inputPayment_cc_number",
                              },
                            ],
                            staticClass: "input-text full-width",
                            class: {
                              invalid: _vm.$v.inputPayment_cc_number.$error,
                            },
                            attrs: {
                              type: "text",
                              id: "'inputPayment_cc_number",
                              name: "inputPayment_cc_number",
                              value: "",
                              placeholder: "",
                            },
                            domProps: { value: _vm.inputPayment_cc_number },
                            on: {
                              input: [
                                function ($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.inputPayment_cc_number =
                                    $event.target.value
                                },
                                function ($event) {
                                  _vm.$v.inputPayment_cc_number.$touch()
                                },
                              ],
                            },
                          }),
                          _vm._v(" "),
                          _vm.$v.inputPayment_cc_number.$dirty &&
                          !_vm.$v.inputPayment_cc_number.required
                            ? _c("p", { staticClass: "errormsg" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.errmsg_required[_vm.getCurrentLocale]
                                  )
                                ),
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.$v.inputPayment_cc_number.$dirty &&
                          !_vm.$v.inputPayment_cc_number.minLength
                            ? _c("p", { staticClass: "errormsg" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.errmsg_min_ccnumber[
                                      _vm.getCurrentLocale
                                    ]
                                  )
                                ),
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.$v.inputPayment_cc_number.$dirty &&
                          !_vm.$v.inputPayment_cc_number.maxLength
                            ? _c("p", { staticClass: "errormsg" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.errmsg_max_ccnumber[
                                      _vm.getCurrentLocale
                                    ]
                                  )
                                ),
                              ])
                            : _vm._e(),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "col-sm-6 col-md-5" }, [
                          _c("label", [
                            _vm._v(
                              _vm._s(_vm.form_cc_cvc[_vm.getCurrentLocale]) +
                                ":* "
                            ),
                            _c("small"),
                          ]),
                          _vm._v(" "),
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.inputPayment_cc_cvc,
                                expression: "inputPayment_cc_cvc",
                              },
                            ],
                            staticClass: "input-text full-width",
                            class: {
                              invalid: _vm.$v.inputPayment_cc_cvc.$error,
                            },
                            attrs: {
                              type: "text",
                              id: "'inputPayment_cc_cvc",
                              name: "inputPayment_cc_cvc",
                              value: "",
                              placeholder: "",
                            },
                            domProps: { value: _vm.inputPayment_cc_cvc },
                            on: {
                              input: [
                                function ($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.inputPayment_cc_cvc = $event.target.value
                                },
                                function ($event) {
                                  _vm.$v.inputPayment_cc_cvc.$touch()
                                },
                              ],
                            },
                          }),
                          _vm._v(" "),
                          _vm.$v.inputPayment_cc_cvc.$dirty &&
                          !_vm.$v.inputPayment_cc_cvc.required
                            ? _c("p", { staticClass: "errormsg" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.errmsg_required[_vm.getCurrentLocale]
                                  )
                                ),
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.$v.inputPayment_cc_cvc.$dirty &&
                          !_vm.$v.inputPayment_cc_cvc.numeric
                            ? _c("p", { staticClass: "errormsg" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.errmsg_numeric[_vm.getCurrentLocale]
                                  )
                                ),
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.$v.inputPayment_cc_cvc.$dirty &&
                          !_vm.$v.inputPayment_cc_cvc.minLength
                            ? _c("p", { staticClass: "errormsg" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.errmsg_min_cccvc[_vm.getCurrentLocale]
                                  )
                                ),
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.$v.inputPayment_cc_cvc.$dirty &&
                          !_vm.$v.inputPayment_cc_cvc.maxLength
                            ? _c("p", { staticClass: "errormsg" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.errmsg_max_cccvc[_vm.getCurrentLocale]
                                  )
                                ),
                              ])
                            : _vm._e(),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "form-group row" }, [
                        _c("div", { staticClass: "col-sm-6 col-md-5" }, [
                          _c("label", [
                            _vm._v(
                              _vm._s(
                                _vm.form_cc_expirationdate[_vm.getCurrentLocale]
                              ) + ":* "
                            ),
                            _c("small"),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "constant-column-2" }, [
                            _c("div", { staticClass: "selector" }, [
                              _c(
                                "select",
                                {
                                  staticClass: "full-width",
                                  attrs: {
                                    id: "inputPayment_cc_expirationmonth",
                                    name: "inputPayment_cc_expirationmonth",
                                  },
                                },
                                _vm._l(
                                  _vm.buildMonths(),
                                  function (month, index) {
                                    return _c(
                                      "option",
                                      {
                                        key: index,
                                        domProps: { value: month.value },
                                      },
                                      [_vm._v(_vm._s(month.text))]
                                    )
                                  }
                                )
                              ),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "selector" }, [
                              _c(
                                "select",
                                {
                                  staticClass: "full-width",
                                  attrs: {
                                    id: "inputPayment_cc_expirationyear",
                                    name: "inputPayment_cc_expirationyear",
                                  },
                                },
                                _vm._l(
                                  _vm.buildYears(),
                                  function (year, index) {
                                    return _c(
                                      "option",
                                      {
                                        key: index,
                                        domProps: { value: year.value },
                                      },
                                      [_vm._v(_vm._s(year.text))]
                                    )
                                  }
                                )
                              ),
                            ]),
                          ]),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("p", { staticStyle: { color: "red" } }, [
                        _vm._v(
                          _vm._s(_vm.creditcardnote[_vm.getCurrentLocale])
                        ),
                      ]),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.showDebit,
                          expression: "showDebit",
                        },
                      ],
                      staticClass: "debit-information",
                    },
                    [
                      _c("h2", [
                        _vm._v(
                          _vm._s(_vm.yourdebitinfo[_vm.getCurrentLocale]) + ":"
                        ),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "form-group row" }, [
                        _c("div", { staticClass: "col-sm-6 col-md-5" }, [
                          _c("label", [
                            _vm._v(
                              _vm._s(
                                _vm.form_dd_accountholder[_vm.getCurrentLocale]
                              ) + ":* "
                            ),
                            _c("small"),
                          ]),
                          _vm._v(" "),
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.inputPayment_dd_accountholder,
                                expression: "inputPayment_dd_accountholder",
                              },
                            ],
                            staticClass: "input-text full-width",
                            class: {
                              invalid:
                                _vm.$v.inputPayment_dd_accountholder.$error,
                            },
                            attrs: {
                              type: "text",
                              id: "'inputPayment_dd_accountholder",
                              name: "inputPayment_dd_accountholder",
                              value: "",
                              placeholder: "",
                            },
                            domProps: {
                              value: _vm.inputPayment_dd_accountholder,
                            },
                            on: {
                              input: [
                                function ($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.inputPayment_dd_accountholder =
                                    $event.target.value
                                },
                                function ($event) {
                                  _vm.$v.inputPayment_dd_accountholder.$touch()
                                },
                              ],
                            },
                          }),
                          _vm._v(" "),
                          _vm.$v.inputPayment_dd_accountholder.$dirty &&
                          !_vm.$v.inputPayment_dd_accountholder.required
                            ? _c("p", { staticClass: "errormsg" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.errmsg_required[_vm.getCurrentLocale]
                                  )
                                ),
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.$v.inputPayment_dd_accountholder.$dirty &&
                          !_vm.$v.inputPayment_dd_accountholder.minLength
                            ? _c("p", { staticClass: "errormsg" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.errmsg_min_company[_vm.getCurrentLocale]
                                  )
                                ),
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.$v.inputPayment_dd_accountholder.$dirty &&
                          !_vm.$v.inputPayment_dd_accountholder.maxLength
                            ? _c("p", { staticClass: "errormsg" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.errmsg_min_company[_vm.getCurrentLocale]
                                  )
                                ),
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.$v.inputPayment_dd_accountholder.$dirty &&
                          !_vm.$v.inputPayment_dd_accountholder.letterspaces
                            ? _c("p", { staticClass: "errormsg" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.errmsg_letterspaces[
                                      _vm.getCurrentLocale
                                    ]
                                  )
                                ),
                              ])
                            : _vm._e(),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "form-group row" }, [
                        _c("div", { staticClass: "col-sm-6 col-md-5" }, [
                          _c("label", [
                            _vm._v(
                              _vm._s(_vm.form_dd_iban[_vm.getCurrentLocale]) +
                                ":* "
                            ),
                            _c("small"),
                          ]),
                          _vm._v(" "),
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.inputPayment_dd_iban,
                                expression: "inputPayment_dd_iban",
                              },
                            ],
                            staticClass: "input-text full-width",
                            class: {
                              invalid: _vm.$v.inputPayment_dd_iban.$error,
                            },
                            attrs: {
                              type: "text",
                              id: "'inputPayment_dd_iban",
                              name: "inputPayment_dd_iban",
                              value: "",
                              placeholder: "",
                            },
                            domProps: { value: _vm.inputPayment_dd_iban },
                            on: {
                              input: [
                                function ($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.inputPayment_dd_iban = $event.target.value
                                },
                                function ($event) {
                                  _vm.$v.inputPayment_dd_iban.$touch()
                                },
                              ],
                            },
                          }),
                          _vm._v(" "),
                          _vm.$v.inputPayment_dd_iban.$dirty &&
                          !_vm.$v.inputPayment_dd_iban.required
                            ? _c("p", { staticClass: "errormsg" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.errmsg_required[_vm.getCurrentLocale]
                                  )
                                ),
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.$v.inputPayment_dd_iban.$dirty &&
                          !_vm.$v.inputPayment_dd_iban.alphaNum
                            ? _c("p", { staticClass: "errormsg" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.errmsg_alphanum[_vm.getCurrentLocale]
                                  )
                                ),
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.$v.inputPayment_dd_iban.$dirty &&
                          !_vm.$v.inputPayment_dd_iban.minLength
                            ? _c("p", { staticClass: "errormsg" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.errmsg_min_iban[_vm.getCurrentLocale]
                                  )
                                ),
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.$v.inputPayment_dd_iban.$dirty &&
                          !_vm.$v.inputPayment_dd_iban.maxLength
                            ? _c("p", { staticClass: "errormsg" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.errmsg_min_iban[_vm.getCurrentLocale]
                                  )
                                ),
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.$v.inputPayment_dd_iban.$dirty &&
                          !_vm.$v.inputPayment_dd_iban.ibanletters
                            ? _c("p", { staticClass: "errormsg" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.errmsg_countrycode_iban[
                                      _vm.getCurrentLocale
                                    ]
                                  )
                                ),
                              ])
                            : _vm._e(),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "col-sm-6 col-md-5" }, [
                          _c("label", [
                            _vm._v(
                              _vm._s(_vm.form_dd_bic[_vm.getCurrentLocale]) +
                                ":* "
                            ),
                            _c("small"),
                          ]),
                          _vm._v(" "),
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.inputPayment_dd_bic,
                                expression: "inputPayment_dd_bic",
                              },
                            ],
                            staticClass: "input-text full-width",
                            class: {
                              invalid: _vm.$v.inputPayment_dd_bic.$error,
                            },
                            attrs: {
                              type: "text",
                              id: "'inputPayment_dd_bic",
                              name: "inputPayment_dd_bic",
                              value: "",
                              placeholder: "",
                            },
                            domProps: { value: _vm.inputPayment_dd_bic },
                            on: {
                              input: [
                                function ($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.inputPayment_dd_bic = $event.target.value
                                },
                                function ($event) {
                                  _vm.$v.inputPayment_dd_bic.$touch()
                                },
                              ],
                            },
                          }),
                          _vm._v(" "),
                          _vm.$v.inputPayment_dd_bic.$dirty &&
                          !_vm.$v.inputPayment_dd_bic.required
                            ? _c("p", { staticClass: "errormsg" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.errmsg_required[_vm.getCurrentLocale]
                                  )
                                ),
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.$v.inputPayment_dd_bic.$dirty &&
                          !_vm.$v.inputPayment_dd_bic.alphaNum
                            ? _c("p", { staticClass: "errormsg" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.errmsg_alphanum[_vm.getCurrentLocale]
                                  )
                                ),
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.$v.inputPayment_dd_bic.$dirty &&
                          !_vm.$v.inputPayment_dd_bic.minLength
                            ? _c("p", { staticClass: "errormsg" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.errmsg_min_bic[_vm.getCurrentLocale]
                                  )
                                ),
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.$v.inputPayment_dd_bic.$dirty &&
                          !_vm.$v.inputPayment_dd_bic.maxLength
                            ? _c("p", { staticClass: "errormsg" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.errmsg_min_bic[_vm.getCurrentLocale]
                                  )
                                ),
                              ])
                            : _vm._e(),
                        ]),
                      ]),
                    ]
                  ),
                  _vm._v(" "),
                  _vm.showCreditcard === true || _vm.showDebit === true
                    ? _c("span", [_c("br"), _c("hr")])
                    : _vm._e(),
                ]),
                _vm._v(" "),
                _c("br"),
                _vm._v(" "),
                _vm.checkValidity()
                  ? _c(
                      "button",
                      {
                        staticClass:
                          "btn-large icon-check uppercase full-width sundairrebooking icon-check4",
                        attrs: { type: "submit" },
                      },
                      [_vm._v(_vm._s(_vm.proceed[_vm.getCurrentLocale]))]
                    )
                  : _vm._e(),
                _vm._v(" "),
                !_vm.checkValidity()
                  ? _c(
                      "a",
                      {
                        staticClass:
                          "button btn-large uppercase full-width silver",
                      },
                      [_vm._v(_vm._s(_vm.proceed[_vm.getCurrentLocale]))]
                    )
                  : _vm._e(),
              ]
            ),
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "sidebar col-sms-6 col-sm-4 col-md-3" },
          [_c("sdr-contact-box")],
          1
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "index" }, [
      _c("i", { staticClass: "soap-icon-arrow-right circle" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }